import { apiClient } from '@/core/apiClient';
import { Lookup, Breed, LookupListParams } from './types';

export const lookupsApi = {
  // Species
  listSpecies: async (params?: LookupListParams) => {
    const response = await apiClient.get('/lookups/species', { params });
    return response.data;
  },
  createSpecies: async (data: Omit<Lookup, 'id'>) => {
    const response = await apiClient.post('/lookups/species', data);
    return response.data.data;
  },
  updateSpecies: async (id: number, data: Partial<Lookup>) => {
    const response = await apiClient.put(`/lookups/species/${id}`, data);
    return response.data.data;
  },
  deleteSpecies: async (id: number) => {
    await apiClient.delete(`/lookups/species/${id}`);
  },

  // Sex
  listSex: async (params?: LookupListParams) => {
    const response = await apiClient.get('/lookups/sex', { params });
    return response.data;
  },
  createSex: async (data: Omit<Lookup, 'id'>) => {
    const response = await apiClient.post('/lookups/sex', data);
    return response.data.data;
  },
  updateSex: async (id: number, data: Partial<Lookup>) => {
    const response = await apiClient.put(`/lookups/sex/${id}`, data);
    return response.data.data;
  },
  deleteSex: async (id: number) => {
    await apiClient.delete(`/lookups/sex/${id}`);
  },

  // Size
  listSize: async (params?: LookupListParams) => {
    const response = await apiClient.get('/lookups/size', { params });
    return response.data;
  },
  createSize: async (data: Omit<Lookup, 'id'>) => {
    const response = await apiClient.post('/lookups/size', data);
    return response.data.data;
  },
  updateSize: async (id: number, data: Partial<Lookup>) => {
    const response = await apiClient.put(`/lookups/size/${id}`, data);
    return response.data.data;
  },
  deleteSize: async (id: number) => {
    await apiClient.delete(`/lookups/size/${id}`);
  },

  // Status
  listStatus: async (params?: LookupListParams) => {
    const response = await apiClient.get('/lookups/status', { params });
    return response.data;
  },
  createStatus: async (data: Omit<Lookup, 'id'>) => {
    const response = await apiClient.post('/lookups/status', data);
    return response.data.data;
  },
  updateStatus: async (id: number, data: Partial<Lookup>) => {
    const response = await apiClient.put(`/lookups/status/${id}`, data);
    return response.data.data;
  },
  deleteStatus: async (id: number) => {
    await apiClient.delete(`/lookups/status/${id}`);
  },

  // Breeds
  listBreeds: async (params?: LookupListParams) => {
    const response = await apiClient.get('/lookups/breeds', { params });
    return response.data;
  },
  createBreed: async (data: Omit<Breed, 'id'>) => {
    const response = await apiClient.post('/lookups/breeds', data);
    return response.data.data;
  },
  updateBreed: async (id: number, data: Partial<Breed>) => {
    const response = await apiClient.put(`/lookups/breeds/${id}`, data);
    return response.data.data;
  },
  deleteBreed: async (id: number) => {
    await apiClient.delete(`/lookups/breeds/${id}`);
  },

  // Colors
  listColors: async (params?: LookupListParams) => {
    const response = await apiClient.get('/lookups/colors', { params });
    return response.data;
  },
  createColor: async (data: Omit<Lookup, 'id'>) => {
    const response = await apiClient.post('/lookups/colors', data);
    return response.data.data;
  },
  updateColor: async (id: number, data: Partial<Lookup>) => {
    const response = await apiClient.put(`/lookups/colors/${id}`, data);
    return response.data.data;
  },
  deleteColor: async (id: number) => {
    await apiClient.delete(`/lookups/colors/${id}`);
  },
};
